export const calculatePercj = (games, team, value) => {
  let FTA = 0;
  let FT = 0;
  let FGA = 0;
  let FG = 0;
  let THREEP = 0;
  let THREEPA = 0;
  let TWOOP = 0;
  let TWOOPA = 0;
  let ORB = 0;
  let DRB = 0;
  let TO = 0;
  let ASS = 0;
  let BLK = 0;
  let BLKR = 0;
  let FL = 0;
  let FLR = 0;
  let STL = 0;
  let MINS = 0;
  let VAL = 0;
  let OppDeffR = 0;
  let OppFGA = 0;
  let OppFTA = 0;
  let OppOffR = 0;
  let OppFG = 0;
  let OppTO = 0;
  let PTS = 0;
  let OppPTS = 0;
  let OppTHREEP = 0;
  let OppTWOOP = 0;
  let OppFT = 0;
  let gamesByTeam = 0;
  let foulsMAde = 0;
  let activeGames = games;
  for (let i = 0; i < games?.length; i++) {
    let gameMins = 0;
    if (activeGames[i].local_team === team) {
      activeGames[i].local_stats.forEach((element) => {
        FGA += Number(element["2pA/I"].split("/")[1]);
        FGA += Number(element["3pA/I"].split("/")[1]);
        FG += Number(element["3pA/I"].split("/")[0]);
        FG += Number(element["2pA/I"].split("/")[0]);
        TWOOP += Number(element["2pA/I"].split("/")[0]);
        THREEP += Number(element["3pA/I"].split("/")[0]);
        TWOOPA += Number(element["2pA/I"].split("/")[1]);
        THREEPA += Number(element["3pA/I"].split("/")[1]);
        FTA += Number(element["tlA/I"].split("/")[1]);
        FT += Number(element["tlA/I"].split("/")[0]);
        TO += Number(element["per"]);
        ORB += Number(element["rebOff"]);
        DRB += Number(element["rebDef"]);
        ASS += Number(element["ass"]);
        STL += Number(element["rec"]);
        BLK += Number(element["blocksMade"]);
        BLKR += Number(element["blocksRecibed"]);
        FL += Number(element["foulsMade"]);
        FLR += Number(element["foulesRecibed"]);
        VAL += Number(element["val"]);
        gameMins += Number(element["mins"].replace(":", "."));
        MINS += Number(element["mins"].replace(":", "."));
      });
      activeGames[i].visit_stats.forEach((element) => {
        OppDeffR += Number(element["rebDef"]);
        OppFGA += Number(element["2pA/I"].split("/")[1]);
        OppFGA += Number(element["3pA/I"].split("/")[1]);
        OppFG += Number(element["2pA/I"].split("/")[0]);
        OppFG += Number(element["3pA/I"].split("/")[0]);
        OppFTA += Number(element["tlA/I"].split("/")[1]);
        OppTO += Number(element["per"]);
        OppOffR += Number(element["rebOff"]);
        OppTHREEP += Number(element["3pA/I"].split("/")[0]);
        OppTWOOP += Number(element["2pA/I"].split("/")[0]);
        OppFT += Number(element["tlA/I"].split("/")[0]);
      });
      gamesByTeam += 1;
    } else if (activeGames[i].visit_team === team) {
      activeGames[i].visit_stats.forEach((element) => {
        FGA += Number(element["2pA/I"].split("/")[1]);
        FGA += Number(element["3pA/I"].split("/")[1]);
        FG += Number(element["2pA/I"].split("/")[0]);
        TWOOP += Number(element["2pA/I"].split("/")[0]);
        FG += Number(element["3pA/I"].split("/")[0]);
        THREEP += Number(element["3pA/I"].split("/")[0]);
        TWOOPA += Number(element["2pA/I"].split("/")[1]);
        THREEPA += Number(element["3pA/I"].split("/")[1]);
        FTA += Number(element["tlA/I"].split("/")[1]);
        FT += Number(element["tlA/I"].split("/")[0]);
        TO += Number(element["per"]);
        VAL += Number(element["val"]);
        ORB += Number(element["rebOff"]);
        DRB += Number(element["rebDef"]);
        ASS += Number(element["ass"]);
        BLK += Number(element["blocksMade"]);
        BLKR += Number(element["blocksRecibed"]);
        FL += Number(element["foulsMade"]);
        FLR += Number(element["foulesRecibed"]);
        STL += Number(element["rec"]);
        gameMins += Number(element["mins"].replace(":", "."));
        MINS += Number(element["mins"].replace(":", "."));
      });
      activeGames[i].local_stats.forEach((element) => {
        OppDeffR += Number(element["rebDef"]);
        OppFGA += Number(element["2pA/I"].split("/")[1]);
        OppFGA += Number(element["3pA/I"].split("/")[1]);
        OppFG += Number(element["2pA/I"].split("/")[0]);
        OppFG += Number(element["3pA/I"].split("/")[0]);
        OppFTA += Number(element["tlA/I"].split("/")[1]);
        OppTO += Number(element["per"]);
        OppOffR += Number(element["rebOff"]);
        OppTHREEP += Number(element["3pA/I"].split("/")[0]);
        OppTWOOP += Number(element["2pA/I"].split("/")[0]);
        OppFT += Number(element["tlA/I"].split("/")[0]);
      });
      gamesByTeam += 1;
    }
  }
  PTS = THREEP * 3 + TWOOP * 2 + FT;
  OppPTS = OppTHREEP * 3 + OppTWOOP * 2 + OppFT;
  let possesion =
    FGA + 0.44 * FTA - 1.07 * (ORB / (ORB + OppDeffR)) * (FGA - FG) + TO;
  let possesionOpp =
    OppFGA +
    0.44 * OppFTA -
    1.07 * (OppOffR / (OppOffR + DRB)) * (OppFGA - OppFG) +
    OppTO;
  let eFG = Math.round(((FG + 0.5 * THREEP) / FGA) * 100);
  let FTR = Math.round((FTA / FGA) * 100);
  let TOR = Math.round((TO * 100) / (FGA + 0.44 * FTA + TO + ASS));
  let OREB = Math.round((ORB / (OppDeffR + ORB)) * 100);
  let DREB = Math.round((DRB / (DRB + OppOffR)) * 100);
  let POSS = Math.round(possesion);
  let POSSOPP = Math.round(possesionOpp);
  let PPP = PTS / (FGA + 0.44 * FTA + TO);
  let ASSR = (ASS * 100) / POSS;
  let OFE = 100 * (PTS / POSS);
  let DFE = 100 * (OppPTS / POSS);
  let TSP = (0.5 * PTS) / [FGA + 0.44 * FTA];
  let NETEFF = OFE - DFE;
  // ADVANCED STATS
  if (value === "PPP") return isNaN(PPP) ? 0 : PPP;
  else if (value === "eFG") return isNaN(eFG) ? 0 : eFG;
  else if (value === "FTR") return isNaN(FTR) ? 0 : FTR;
  else if (value === "OFE") return isNaN(OFE) ? 0 : OFE;
  else if (value === "DFE") return isNaN(DFE) ? 0 : DFE;
  else if (value === "NETEFF") return isNaN(NETEFF) ? 0 : NETEFF;
  else if (value === "TOR") return isNaN(TOR) ? 0 : TOR;
  else if (value === "OREB") return isNaN(OREB) ? 0 : OREB;
  else if (value === "DREB") return isNaN(DREB) ? 0 : DREB;
  else if (value === "POSS") return isNaN(POSS) ? 0 : POSS / gamesByTeam;
  else if (value === "POSSOPP")
    return isNaN(POSSOPP / gamesByTeam) ? 0 : POSSOPP / gamesByTeam;
  else if (value === "ASSR") return isNaN(ASSR) ? 0 : ASSR;
  else if (value === "TSP") return isNaN(TSP) ? 0 : TSP * 100;
  // BASIC STATS
  else if (value === "PTS")
    return isNaN(PTS / gamesByTeam) ? 0 : PTS / gamesByTeam;
  else if (value === "PTSTot") return isNaN(PTS) ? 0 : PTS;
  else if (value === "OppPTS") return OppPTS / gamesByTeam;
  else if (value === "REB")
    return isNaN((ORB + DRB) / gamesByTeam) ? 0 : (ORB + DRB) / gamesByTeam;
  else if (value === "ORB")
    return isNaN(ORB / gamesByTeam) ? 0 : ORB / gamesByTeam;
  else if (value === "ORBTot") return isNaN(ORB) ? 0 : ORB;
  else if (value === "DRB")
    return isNaN(DRB / gamesByTeam) ? 0 : DRB / gamesByTeam;
  else if (value === "DRBTot") return isNaN(DRB) ? 0 : DRB;
  else if (value === "ASS")
    return isNaN(ASS / gamesByTeam) ? 0 : ASS / gamesByTeam;
  else if (value === "ASSTot") return isNaN(ASS) ? 0 : ASS;
  else if (value === "STL")
    return isNaN(STL / gamesByTeam) ? 0 : STL / gamesByTeam;
  else if (value === "STLTot") return isNaN(STL) ? 0 : STL;
  else if (value === "BLK")
    return isNaN(BLK / gamesByTeam) ? 0 : BLK / gamesByTeam;
  else if (value === "BLKR")
    return isNaN(BLKR / gamesByTeam) ? 0 : BLKR / gamesByTeam;
  else if (value === "BLKTot") return isNaN(BLK) ? 0 : BLK;
  else if (value === "FL")
    return isNaN(FL / gamesByTeam) ? 0 : FL / gamesByTeam;
  else if (value === "FLR")
    return isNaN(FLR / gamesByTeam) ? 0 : FLR / gamesByTeam;
  else if (value === "PFTot") return FL;
  else if (value === "TO")
    return isNaN(TO / gamesByTeam) ? 0 : TO / gamesByTeam;
  else if (value === "FGA")
    return isNaN(FGA / gamesByTeam) ? 0 : FGA / gamesByTeam;
  else if (value === "FG")
    return isNaN(FG / gamesByTeam) ? 0 : FG / gamesByTeam;
  else if (value === "FGTot") return isNaN(FG) ? 0 : FG;
  else if (value === "FGP") return isNaN(FG / FGA) ? 0 : (FG / FGA) * 100;
  else if (value === "THREEPA")
    return isNaN(THREEPA / gamesByTeam) ? 0 : THREEPA / gamesByTeam;
  else if (value === "THREEP")
    return isNaN(THREEP / gamesByTeam) ? 0 : THREEP / gamesByTeam;
  else if (value === "THREEPP")
    return isNaN((THREEP / THREEPA) * 100) ? 0 : (THREEP / THREEPA) * 100;
  else if (value === "TWOOPA")
    return isNaN(TWOOPA / gamesByTeam) ? 0 : TWOOPA / gamesByTeam;
  else if (value === "TWOOP")
    return isNaN(TWOOP / gamesByTeam) ? 0 : TWOOP / gamesByTeam;
  else if (value === "TWOOPP")
    return isNaN((TWOOP / TWOOPA) * 100) ? 0 : (TWOOP / TWOOPA) * 100;
  else if (value === "FTA")
    return isNaN(FTA / gamesByTeam) ? 0 : FTA / gamesByTeam;
  else if (value === "FTATot") return isNaN(FTA) ? 0 : FTA;
  else if (value === "FT")
    return isNaN(FT / gamesByTeam) ? 0 : FT / gamesByTeam;
  else if (value === "FTP")
    return isNaN((FT / FTA) * 100) ? 0 : (FT / FTA) * 100;
  else if (value === "FGATot") return isNaN(FGA) ? 0 : FGA;
  else if (value === "FTTot") return isNaN(FTA) ? 0 : FTA;
  else if (value === "TORTot") return isNaN(TO) ? 0 : TO;
  else if (value === "TORP")
    return isNaN(TO / gamesByTeam) ? 0 : TO / gamesByTeam;
  else if (value === "POSSTot") return isNaN(POSS) ? 0 : POSS;
  else if (value === "MINS") return isNaN(MINS) ? 0 : Math.ceil(MINS / 5) * 5;
  else if (value === "MINSP")
    return isNaN((Math.ceil(MINS / 5) * 5) / gamesByTeam)
      ? 0
      : MINS / gamesByTeam;
  else if (value === "VAL")
    return isNaN(VAL / gamesByTeam) ? 0 : VAL / gamesByTeam;
};
export const calculatePlayerStats = (
  games,
  player,
  value,
  startDate,
  endDate
) => {
  let FTA = 0;
  let FT = 0;
  let FGA = 0;
  let FG = 0;
  let THREEP = 0;
  let THREEPA = 0;
  let TWOOP = 0;
  let TWOOPA = 0;
  let ORB = 0;
  let DRB = 0;
  let TO = 0;
  let ASS = 0;
  let BLK = 0;
  let FL = 0;
  let STL = 0;
  let MINS = 0;
  let MINSTEAM = 0;
  let OppDeffR = 0;
  let OppFGA = 0;
  let OppFTA = 0;
  let OppOffR = 0;
  let OppFG = 0;
  let OppTO = 0;
  let PTS = 0;
  let OppPTS = 0;
  let OppTHREEP = 0;
  let OppTWOOP = 0;
  let OppFT = 0;
  let gamesByTeam = 0;
  let gamesByPlayer = 0;
  let FGATEAM = 0;
  let FTTEAM = 0;
  let TORTEAM = 0;
  let VAL = 0;

  let activeGames = games;

  for (let i = 0; i < activeGames?.length; i++) {
    let localPlayer = games[i].local_stats.filter(
      (vendor) => vendor["player_id"] === player
    );
    let visitPlayer = games[i].visit_stats.filter(
      (vendor) => vendor["player_id"] === player
    );
    if (localPlayer.length > 0) {
      // eslint-disable-next-line no-loop-func
      localPlayer.forEach((element) => {
        FGA += Number(element["2pA/I"].split("/")[1]);
        FGA += Number(element["3pA/I"].split("/")[1]);
        FG += Number(element["3pA/I"].split("/")[0]);
        FG += Number(element["2pA/I"].split("/")[0]);
        TWOOP += Number(element["2pA/I"].split("/")[0]);
        THREEP += Number(element["3pA/I"].split("/")[0]);
        TWOOPA += Number(element["2pA/I"].split("/")[1]);
        THREEPA += Number(element["3pA/I"].split("/")[1]);
        FTA += Number(element["tlA/I"].split("/")[1]);
        FT += Number(element["tlA/I"].split("/")[0]);
        TO += Number(element["per"]);
        ORB += Number(element["rebOff"]);
        DRB += Number(element["rebDef"]);
        ASS += Number(element["ass"]);
        STL += Number(element["rec"]);
        BLK += Number(element["blocksMade"]);
        FL += Number(element["foulsMade"]);
        VAL += Number(element["val"]);
        let minutos = element["mins"].replace(":", ".");
        minutos.replace(":", ".");
        MINS += Number(minutos);
        if (Number(minutos) > 0) gamesByPlayer += 1;
      });
      //STATS FOR PLAYERS TEAM
      // eslint-disable-next-line no-loop-func
      activeGames[i].local_stats.forEach((element) => {
        let minutos = element["mins"].replace(":", ".");
        minutos.replace(":", ".");
        MINSTEAM += Number(minutos);
        FGATEAM += Number(element["2pA/I"].split("/")[1]);
        FGATEAM += Number(element["3pA/I"].split("/")[1]);
        FTTEAM += Number(element["tlA/I"].split("/")[1]);
        TORTEAM += Number(element["per"]);
      });

      //STATS FOR PLAYERS RIVAL TEAM
      // eslint-disable-next-line no-loop-func
      activeGames[i].visit_stats.forEach((element) => {
        OppDeffR += Number(element["rebDef"]);
        OppFGA += Number(element["2pA/I"].split("/")[1]);
        OppFGA += Number(element["3pA/I"].split("/")[1]);
        OppFG += Number(element["2pA/I"].split("/")[0]);
        OppFG += Number(element["3pA/I"].split("/")[0]);
        OppFTA += Number(element["tlA/I"].split("/")[1]);
        OppTO += Number(element["per"]);
        OppOffR += Number(element["rebOff"]);
        OppTHREEP += Number(element["3pA/I"].split("/")[0]);
        OppTWOOP += Number(element["2pA/I"].split("/")[0]);
        OppFT += Number(element["tlA/I"].split("/")[0]);
      });
      gamesByTeam += 1;
    } else if (visitPlayer.length > 0) {
      // eslint-disable-next-line no-loop-func
      visitPlayer.forEach((element) => {
        FGA += Number(element["2pA/I"].split("/")[1]);
        FGA += Number(element["3pA/I"].split("/")[1]);
        FG += Number(element["2pA/I"].split("/")[0]);
        FG += Number(element["3pA/I"].split("/")[0]);
        TWOOP += Number(element["2pA/I"].split("/")[0]);
        THREEP += Number(element["3pA/I"].split("/")[0]);
        TWOOPA += Number(element["2pA/I"].split("/")[1]);
        THREEPA += Number(element["3pA/I"].split("/")[1]);
        FTA += Number(element["tlA/I"].split("/")[1]);
        FT += Number(element["tlA/I"].split("/")[0]);
        TO += Number(element["per"]);
        ORB += Number(element["rebOff"]);
        DRB += Number(element["rebDef"]);
        ASS += Number(element["ass"]);
        BLK += Number(element["blocksMade"]);
        FL += Number(element["foulsMade"]);
        STL += Number(element["rec"]);
        VAL += Number(element["val"]);
        let minutos = element["mins"].replace(":", ".");
        minutos.replace(":", ".");
        MINS += Number(minutos);
        if (Number(minutos) > 0) gamesByPlayer += 1;
      });

      // eslint-disable-next-line no-loop-func
      activeGames[i].visit_stats.forEach((element) => {
        let minutos = element["mins"].replace(":", ".");
        minutos.replace(":", ".");
        MINSTEAM += Number(minutos);
        FGATEAM += Number(element["2pA/I"].split("/")[1]);
        FGATEAM += Number(element["3pA/I"].split("/")[1]);
        FTTEAM += Number(element["tlA/I"].split("/")[1]);
        TORTEAM += Number(element["per"]);
      });
      // eslint-disable-next-line no-loop-func
      activeGames[i].local_stats.forEach((element) => {
        OppDeffR += Number(element["rebDef"]);
        OppFGA += Number(element["2pA/I"].split("/")[1]);
        OppFGA += Number(element["3pA/I"].split("/")[1]);
        OppFG += Number(element["2pA/I"].split("/")[0]);
        OppFG += Number(element["3pA/I"].split("/")[0]);
        OppFTA += Number(element["tlA/I"].split("/")[1]);
        OppTO += Number(element["per"]);
        OppOffR += Number(element["rebOff"]);
        OppTHREEP += Number(element["3pA/I"].split("/")[0]);
        OppTWOOP += Number(element["2pA/I"].split("/")[0]);
        OppFT += Number(element["tlA/I"].split("/")[0]);
      });
      gamesByTeam += 1;
    }
  }
  PTS = THREEP * 3 + TWOOP * 2 + FT;
  OppPTS = OppTHREEP * 3 + OppTWOOP * 2 + OppFT;
  let possesion =
    FGA + 0.44 * FTA - 1.07 * (ORB / (ORB + OppDeffR)) * (FGA - FG) + TO;
  let oppPossesion =
    OppFTA +
    0.44 * OppFTA -
    1.07 * (OppOffR / (OppOffR + DRB)) * (OppFTA - OppFG) +
    OppTO;

  let eFG = ((FG + 0.5 * THREEP) / FGA) * 100;
  let FTR = Math.round((FTA / FGA) * 100);
  let TOR = Math.round((TO * 100) / (FGA + 0.44 * FTA + TO + ASS));
  let OREB = Math.round((ORB / (OppDeffR + ORB)) * 100);
  let DREB = Math.round((DRB / (DRB + OppOffR)) * 100);
  let POSS = Math.round(possesion);
  let PPP = PTS / (FGA + 0.44 * FTA + TO);
  let ASSR = (ASS * 100) / POSS;
  let OFE = 100 * (PTS / POSS);
  let DFE = 100 * (OppPTS / oppPossesion);
  let TSP = (0.5 * PTS) / [FGA + 0.44 * FTA];
  let USG = (
    100 *
    ((FGA + 0.44 * (FTA + TO) * MINSTEAM) /
      (FGATEAM + 0.44 * (FTTEAM + TORTEAM) * 5 * MINS))
  ).toFixed(1);

  // ADVANCED STATS
  if (value === "PPP") return isNaN(PPP) ? 0 : PPP;
  else if (value === "eFG") return isNaN(eFG) ? 0 : eFG.toFixed(1);
  else if (value === "FTR") return isNaN(FTR) ? 0 : FTR.toFixed(1);
  else if (value === "OFE") return isNaN(OFE) ? 0 : OFE;
  else if (value === "DFE") return isNaN(DFE) ? 0 : DFE;
  else if (value === "TOR") return isNaN(TOR) ? 0 : TOR;
  else if (value === "OREB") return isNaN(OREB) ? 0 : OREB.toFixed(1);
  else if (value === "DREB") return isNaN(DREB) ? 0 : DREB;
  else if (value === "POSS") return isNaN(POSS) ? 0 : POSS / gamesByPlayer;
  else if (value === "POSSTot") return isNaN(POSS) ? 0 : POSS;
  else if (value === "ASSR") return isNaN(ASSR) ? 0 : ASSR;
  else if (value === "TSP") return isNaN(TSP) ? 0 : (TSP * 100).toFixed(1);
  // BASIC STATS
  else if (value === "PTS")
    return isNaN(PTS / gamesByPlayer) ? 0 : (PTS / gamesByPlayer).toFixed(1);
  else if (value === "PTSTot") return isNaN(PTS) ? 0 : PTS.toFixed(1);
  else if (value === "OppPTS")
    return isNaN(OppPTS) ? 0 : OppPTS / gamesByPlayer;
  else if (value === "REB")
    return ORB + DRB > 0
      ? ((ORB + DRB) / gamesByPlayer).toFixed(1)
      : (ORB + DRB) / gamesByPlayer;
  else if (value === "REBTot") return ORB + DRB > 0 ? ORB + DRB : ORB + DRB;
  else if (value === "ORB")
    return isNaN(ORB / gamesByPlayer) ? 0 : (ORB / gamesByPlayer).toFixed(1);
  else if (value === "ORBTot") return isNaN(ORB) ? 0 : ORB;
  else if (value === "DRB")
    return isNaN(DRB / gamesByPlayer) ? 0 : (DRB / gamesByPlayer).toFixed(1);
  else if (value === "DRBTot") return isNaN(DRB) ? 0 : DRB;
  else if (value === "ASS")
    return isNaN(ASS / gamesByPlayer) ? 0 : (ASS / gamesByPlayer).toFixed(1);
  else if (value === "ASSTot") return isNaN(ASS) ? 0 : ASS;
  else if (value === "STL")
    return isNaN(STL / gamesByPlayer) ? 0 : (STL / gamesByPlayer).toFixed(1);
  else if (value === "STLTot") return isNaN(STL) ? 0 : STL;
  else if (value === "BLK")
    return isNaN(BLK / gamesByPlayer) ? 0 : (BLK / gamesByPlayer).toFixed(1);
  else if (value === "BLKTot") return isNaN(BLK) ? 0 : BLK;
  else if (value === "FL")
    return isNaN(FL / gamesByPlayer) ? 0 : (FL / gamesByPlayer).toFixed(1);
  else if (value === "FLTot") return isNaN(FL) ? 0 : FL;
  else if (value === "TO")
    return isNaN(TO / gamesByPlayer) ? 0 : (TO / gamesByPlayer).toFixed(1);
  else if (value === "TORTot") return isNaN(TO) ? 0 : TO;
  else if (value === "FGA") return isNaN(FGA) ? 0 : FGA / gamesByPlayer;
  else if (value === "FGATot") return isNaN(FGA) ? 0 : FGA;
  else if (value === "FG")
    return isNaN(FG / gamesByPlayer) ? 0 : (FG / gamesByPlayer).toFixed(1);
  else if (value === "FGTot") return isNaN(FG) ? 0 : FG;
  else if (value === "FGP")
    return isNaN((FG / FGA) * 100) ? 0 : ((FG / FGA) * 100).toFixed(1);
  else if (value === "THREEPA")
    return isNaN(THREEPA) ? 0 : THREEPA / gamesByPlayer;
  else if (value === "THREEPATot") return isNaN(THREEPA) ? 0 : THREEPA;
  else if (value === "THREEP")
    return (isNaN(THREEP / gamesByPlayer) ? 0 : THREEP / gamesByPlayer).toFixed(
      1
    );
  else if (value === "THREEPTot") return isNaN(THREEP) ? 0 : THREEP;
  else if (value === "THREEPP")
    return THREEP / THREEPA === Infinity || isNaN(THREEP / THREEPA)
      ? 0
      : ((THREEP / THREEPA) * 100).toFixed(1);
  else if (value === "TWOOPATot") return isNaN(TWOOPA) ? 0 : TWOOPA;
  else if (value === "TWOOPA")
    return isNaN(TWOOPA) ? 0 : TWOOPA / gamesByPlayer;
  else if (value === "TWOOP")
    return (isNaN(TWOOP / gamesByPlayer) ? 0 : TWOOP / gamesByPlayer).toFixed(
      1
    );
  else if (value === "TWOOPTot") return isNaN(TWOOP) ? 0 : TWOOP;
  else if (value === "TWOOPP")
    return TWOOP / TWOOPA === Infinity || isNaN(TWOOP / TWOOPA)
      ? 0
      : ((TWOOP / TWOOPA) * 100).toFixed(1);
  else if (value === "FTA") return isNaN(FTA) ? 0 : FTA / gamesByPlayer;
  else if (value === "FTATot") return isNaN(FTA) ? 0 : FTA;
  else if (value === "FTTot") return isNaN(FT) ? 0 : FT;
  else if (value === "FT")
    return isNaN(FT / gamesByPlayer) ? 0 : (FT / gamesByPlayer).toFixed(1);
  else if (value === "FTP")
    return FT / FTA === Infinity || isNaN(FT / FTA)
      ? 0
      : ((FT / FTA) * 100).toFixed(1);
  else if (value === "MINS") return isNaN(MINS) ? 0 : MINS;
  else if (value === "GAMES") return isNaN(gamesByPlayer) ? 0 : gamesByPlayer;
  else if (value === "MINSP")
    return isNaN(MINS / gamesByPlayer) ? 0 : (MINS / gamesByPlayer).toFixed(1);
  else if (value === "USG") return isNaN(USG) ? 0 : USG;
  else if (value === "VAL")
    return isNaN(VAL) ? 0 : (VAL / gamesByPlayer).toFixed(1);
};
